import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployees } from "../redux/slieces/employeeSlice";
import EmployeeManagement from "../components/EmployeeManagement";
import OrganisationManagement from "../components/OrganisationManagement";
import OrganizationSettings from "../components/OrganizationSettings";
import { Tabs, Card, Breadcrumb, Space, Divider } from "antd";
import { HomeOutlined, TeamOutlined, BankOutlined, SettingOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import styles from "./OrganisationPage.module.css";

const { TabPane } = Tabs;

const OrganisationPage = () => {
    const dispatch = useDispatch();
    const { employees, loading, hasErrors } = useSelector((state) => state.employees);
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState("organisations");

    useEffect(() => {
        dispatch(fetchEmployees());
    }, [dispatch]);

    const handleTabChange = (key) => {
        setActiveTab(key);
    };

    const tabItems = [
        {
            key: "organisations",
            label: (
                <Space>
                    <BankOutlined />
                    {t("organisationManagement")}
                </Space>
            ),
            children: (
                <div className={styles.tabContent}>
                    <OrganisationManagement />
                </div>
            ),
        },
        {
            key: "employees",
            label: (
                <Space>
                    <TeamOutlined />
                    {t("employeeManagement")}
                </Space>
            ),
            children: (
                <div className={styles.tabContent}>
                    <EmployeeManagement />
                </div>
            ),
        },
        {
            key: "settings",
            label: (
                <Space>
                    <SettingOutlined />
                    {t("organizationSettings")}
                </Space>
            ),
            children: (
                <div className={styles.tabContent}>
                    <OrganizationSettings />
                </div>
            ),
        },
    ];

    return (
        <div className={styles.organisationPageContainer}>
            {/* Breadcrumb Navigation */}
            <div className={styles.breadcrumbContainer}>
                <Breadcrumb
                    items={[
                        {
                            href: "/",
                            title: (
                                <Space>
                                    <HomeOutlined />
                                    {t("home.title")}
                                </Space>
                            ),
                        },
                        {
                            title: t("organisation"),
                        },
                    ]}
                />
            </div>

            {/* Page Header */}
            <div className={styles.pageHeader}>
                <div className={styles.headerContent}>
                    <div className={styles.titleSection}>
                        <h1 className={styles.pageTitle}>
                            <BankOutlined className={styles.titleIcon} />
                            {t("organisation")}
                        </h1>
                        <p className={styles.pageDescription}>
                            {t("organisationPageDescription")}
                        </p>
                    </div>
                </div>
            </div>

            <Divider className={styles.headerDivider} />

            {/* Main Content */}
            <div className={styles.mainContent}>
                <Card className={styles.contentCard}>
                    <Tabs
                        activeKey={activeTab}
                        onChange={handleTabChange}
                        type="card"
                        size="large"
                        className={styles.mainTabs}
                        items={tabItems}
                    />
                </Card>
            </div>
        </div>
    );
};

export default OrganisationPage;
